<template>
  <v-form ref="form_simulator" v-model="valid" lazy-validation>
    <v-container nowrap>
      <v-card class="elevation-0" height="100%">
        <v-card-title class="font-weight-bold">Simulador</v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Média de Consumo"
                  v-model.number="average_consumption"
                  name="average_consumption"
                  prefix="R$"
                  type="number"
                ></v-text-field>
                <v-radio-group
                  v-if="!this.user || (this.user && !this.user.person_type)"
                  v-model="person_type"
                  :rules="[
                    (v) => !!v || 'Por favor, selecione o tipo de pessoa!',
                  ]"
                  row
                  required
                >
                  <v-radio label="Pessoa Física" value="pf"></v-radio>
                  <v-radio label="Pessoa Jurídica" value="pj"></v-radio>
                </v-radio-group>
                <v-autocomplete
                  v-if="!this.user || (this.user && !this.user.utility_company)"
                  :items="utilityCompanies"
                  item-text="name"
                  item-value="id"
                  label="Concessionária"
                  v-model="utility_company"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container
            fluid
            grid-list-lg
            v-if="average_consumption > 0"
            class="pa-0 ma-0"
          >
            <v-layout row wrap>
              <v-flex xs12>
                <SimulatorCard
                  v-for="item in plansEconomySort"
                  :key="item.id"
                  :plan_name="item.name"
                  :economy_year="item.economy_year"
                  :economy_mounth="item.economy_mounth"
                  :discount="Number(item.discount)"
                  :recommended="item.recommended"
                >
                </SimulatorCard>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SimulatorCard from "./SimulatorCard.vue";

export default {
  data: () => ({
    local_user: {},
    plans_economy: [],
    valid: false,
  }),

  mounted() {
    if (this?.plan?.id) {
      this.getPlansEconomy(this.average_consumption, [this.plan]);
    } else {
      this.getPlansEconomy(this.average_consumption, this.default_plan);
    }
  },

  computed: {
    ...mapState("sales", ["coupon", "user", "plan", "plans"]),
    ...mapState("configuration", ["loading", "utilityCompanies"]),
    ...mapGetters("sales", ["filteredPlans"]),
    average_consumption: {
      get() {
        return this.$store.state.sales.user?.average_consumption;
      },
      set(value) {
        this.$store.commit("sales/setAverageConsumption", value);
      },
    },
    utility_company: {
      get() {
        return this.$store.state.sales.user?.utility_company;
      },
      set(value) {
        this.$store.commit("sales/setUtilityCompany", value);
      },
    },
    person_type: {
      get() {
        return this.$store.state.sales.user?.person_type;
      },
      set(value) {
        this.$store.commit("sales/setPersonType", value);
      },
    },

    select_plans() {
      if (this.user?.coupon?.plan_id)
        return this.filteredPlans({ plan_id: this.user?.coupon?.plan_id });
      else if (this.user?.plan?.id)
        return this.filteredPlans({ plan_id: this.user?.plan?.id });
      else
        return this.filteredPlans({
          person_type: this.person_type,
          utility_company: this.utility_company,
          company: "juntos",
        });
    },

    default_plan() {
      return this.filteredPlans({
        person_type: this.person_type,
        utility_company: this.utility_company,
        company: "juntos",
      });
    },

    plansEconomySort() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.plans_economy.sort((a, b) => (a.order > b.order ? 1 : -1));
    },
  },

  watch: {
    average_consumption() {
      if (this.average_consumption > 0) {
        if (this?.plan?.id) {
          this.getPlansEconomy(this.average_consumption, [this.plan]);
        } else {
          this.getPlansEconomy(this.average_consumption, this.default_plan);
        }
      }
    },
    plan() {
      if (this?.plan?.id) {
        this.getPlansEconomy(this.average_consumption, [this.plan]);
      } else {
        this.getPlansEconomy(this.average_consumption, this.default_plan);
      }
    },
  },

  created() {
    if (this.user) this.local_user = this.user;
    if (this.utilityCompanies.length <= 0) this.getUtilityCompanies();
    if (!this.plans || this.plans.length <= 0) {
      this.getAllPlans();
    }
  },
  methods: {
    ...mapActions("sales", ["getCoupons", "getAllPlans"]),
    ...mapActions("configuration", ["getUtilityCompanies"]),

    getPlansEconomy(average_consumption, plans) {
      this.plans_economy = [];
      for (const plan of plans) {
        let mounth =
          (average_consumption * (1 - 0.09) - 50) *
          (plan.discount / 100 || 0.13);
        let year = mounth * 12;
        this.plans_economy.push({
          economy_mounth: mounth,
          economy_year: year,
          ...plan,
        });
      }
    },
  },
  components: { SimulatorCard },
};
</script>
